import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Injector, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { ServiceChargeDetailsService } from '@nano/common/classifier';

@Pipe({
  name: 'serviceChargeDetails',
  pure: false,
  standalone: false
})
export class ServiceChargeDetailsPipe implements PipeTransform, OnDestroy {
  private asyncPipe: AsyncPipe;

  constructor(
    private serviceChargeDetailsService: ServiceChargeDetailsService,
    private injector: Injector
  ) {
    this.asyncPipe = new AsyncPipe(this.injector.get(ChangeDetectorRef));
  }

  ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  transform(value: string): string {
    return !value
      ? ''
      : this.asyncPipe.transform(
          this.serviceChargeDetailsService.serviceChargeDetails$.pipe(
            take(1),
            map((classifiers) => classifiers.find((classifier) => classifier.id === value)?.label)
          )
        );
  }
}
